import theme from "../features/Theme/theme"
import isIphoneX from "./isIphoneX"

const getFooterHeight = () => (isIphoneX ? theme.dimensions.spacing * 2 : 0)

export default getFooterHeight
